import type { ReactNode } from 'react';
import { Dropdown } from './Dropdown';
import { Icon, type IconName } from './Icon';
import { IconButton } from './IconButton';

export type RowMenuItem = {
  icon?: IconName;
  label: ReactNode;
  onClick: () => void;
  danger?: boolean;
};

export type RowMenuProps = {
  items: Array<RowMenuItem | 'divider'>;
};

/**
 * Compact "more actions" button that opens a dropdown of row-scoped actions.
 * Used by every CRUD table (settings, HRM, users).
 */
export function RowMenu({ items }: RowMenuProps) {
  return (
    <Dropdown trigger={<IconButton name="more" label="Row actions" />}>
      {items.map((item, i) => {
        if (item === 'divider') return <div key={`d-${i}`} className="dropdown-divider" />;
        return (
          <button
            key={i}
            type="button"
            className={`dropdown-item ${item.danger ? 'danger' : ''}`}
            onClick={item.onClick}
          >
            {item.icon && <Icon name={item.icon} size={14} />}
            {item.label}
          </button>
        );
      })}
    </Dropdown>
  );
}
